<template>
<!-- 慕课详情 -->
    <div class="localFeature_detail_warp">
        <BaseDetail>
            <div slot="top" class="video_box">
                <div class="video_l">
                    <!-- 视频 -->
                    <div class="video_l_content" v-if="false"></div>
                    <div class="video_l_content" v-if="true">
                        <img class="video_img" src="https://www.ynggwhy.cn/file/hbY3dGDs5jDBxn6RTX/2020-11-13/source/52a7b3cfce08466fbbe83f2414b91ed0.jpeg" alt="">
                    </div>
                    <div class="video_l_footer">
                        <div class="cont_top_title">云南民间故事展演</div>
                        <div class="behavior_box">
                            <div style="color:#2f69ed;">播放 30 </div>
                            <div class="behavior_list">
                                <div class="behavior_item">
                                    <svg-icon icon-class="thumb" class-name="item_icon" /> 0
                                </div>
                                <div class="behavior_item">
                                    <i class="el-icon-star-off item_icon"  /> 0
                                </div>
                                <div class="behavior_item">
                                    <i class="el-icon-share item_icon"/> 分享
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="video_r">
                    <div class="video_r_title">地方饮食</div>
                    <div class="video_r_list">
                        <div class="r_list_item">
                            <i class="el-icon-video-play play_icon"></i>
                            <span class="name ellipsis">哈么妮合唱工作坊·青年指挥家邓卓锐公益课堂   第一节</span>
                            <span>43:57</span>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="cont" class="cont_warp">
               
            </div>
        </BaseDetail>
    </div>
</template>

<script>
import BaseDetail from '@c/BaseDetail'

export default {
    name: 'localFeatureDetail',
    components: {
        BaseDetail
    },
    data() {
        return {

        }
    },
    methods: {

    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">
.localFeature_detail_warp {
    background: #f8f8f8;
    min-height: calc(100vh - 315px);
    .video_box {
        width: 100%;
        background: #000;
        display: flex;
        margin-top: 20px;
        box-sizing: border-box;
        .video_l {
            width: 845px;
            border-right: 1px solid #919191;
        }
        .video_l_content {
            height: 477px;
            position: relative;
        
        }
        .video_img {
            width: 100%;
            height: 100%;
        }
        .video_l_footer {
            padding: 27px 30px 30px;
            line-height: 1;
            font-size: 20px;
        }
        .cont_top_title {
            font-size: 24px;
            font-weight: 800;
            color: #fff;
        }
        .behavior_box {
            display: flex;
            align-items: center;
            font-size: 20px;
            color: #777;
            padding: 27px 0 20px;
        }
        .behavior_list {
            margin-left: auto;
            display: flex;
            .behavior_item {
                width: 118px;
                height: 47px;
                line-height: 47px;
                text-align: center;
                border-radius: 5px;
                background: #f5f5f5;
                cursor: pointer;
                margin-left: 18px;
            }
        }
        .item_icon {
            font-size: 23px;
        }
        .video_r {
            flex: 1;
            overflow: hidden;
        }
        .video_r_list {
            height: 600px;
            padding: 20px 20px 0 20px;
            overflow-y: auto;
        }
        .r_list_item {
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;            
            margin-bottom: 15px;
            cursor: pointer;
            color: #fff;
            font-size: 20px;
            &.active {
                color: #2f7ef7;
            }
            .play_icon {
                font-size: 27px;
            }
            .name {
                flex: 1;
                margin-left: 8px;
            }
        }
        .video_r_title {
            height: 58px;
            padding-left: 20px;
            line-height: 58px;
            text-align: left;
            font-size: 24px;
            font-weight: 800;
            color: #fff;
            border-bottom: 1px solid #919191;
        }
    }
    .cont_warp {
        width: 100%;
        background: #fff;
        box-shadow: 0 10px 18px 0 rgba(0,0,0,.05);
        border-radius: 5px;
        padding: 45px 30px;
    }
}
</style>